/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EdrCloudInstancePatchSpec { 
    /**
     * Description of the cloud instance.
     */
    description?: string;
    /**
     * Internal description.
     */
    internal_description?: string;
}

